<template>
<div class="chapter">
<div class="inner_page">
<p class="imagep"><span><a id="page_10"><img alt="" height="32" src="images/stara.jpg" width="109"/></a></span></p><a id="page_10">
</a><p class="chtitle" id="rch04"><a id="page_10"><span></span></a><a href="#/Contents#ch04">FUELING FOR FITNESS</a></p>
<p class="normalta"><span>Just as fuel is important for a vehicle, so is food — more importantly, the right foods — for the body. I use this correlation because you have to treat your body as if it’s a luxury car. Yes, you can put cheaper-quality gasoline in your car and it will still function, but not at the high level at which your car is capable of performing. The same goes for eating.</span></p>
<p class="normalt"><span>Whatever you ingest, good or bad, will have a positive or negative effect on your performance. To get the maximum physical results from this program, it’s important to incorporate a nutrition plan consisting of lean meats, fruits, vegetables and water. Limit your intake of fried, processed and other foods that are considered “unhealthy,” as well as alcohol, candy and any carbonated drink. If you’re not sure which foods you should eat, seek a local nutritionist for assistance. It’s true that you are what you eat, so choose wisely!</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter04.vue?1569b800